import React, { FC, useState } from 'react'
import { FormikHelpers } from 'formik'

import CustomPopup from '../../UI/Popup'
import CustomButton from '../../UI/Buttons/CustomButton'
import UploadImage from '../../UploadCropImage'
import GeneralForm from '../../Form'
import TextInput from '../../UI/Inputs/TextInput'

import { toggleEditProfileModalAction } from '../../../store/application/slice'
import { useDispatch, useSelector } from '../../../store'

import './EditProfileModal.scss'
import { updateUserThunk } from '../../../store/auth/thunks'
import { isFulfilled } from '@reduxjs/toolkit'
import { Link } from 'react-router-dom'
import { NON_AUTH_ROUTE } from '../../../pages/App/routes'

const AddProjectModal: FC<any> = () => {
  const dispatch = useDispatch()
  const close = () => {
    dispatch(toggleEditProfileModalAction())
  }

  const [image, setImage] = useState<any>(null)
  const { inProgress, isOpenEditProfile, user } = useSelector((state) => ({
    inProgress: state.auth.inProgress,
    isOpenEditProfile: state.app.isOpenEditProfile,
    user: state.auth.user
  }))

  const setUpForm = {
    initialValues: { name: user?.name },
    validation: 'user',
    onSubmit: async (values: any, actions: FormikHelpers<any>) => {
      const data = new FormData()
      data.append('name', values.name)

      if (image) {
        data.append('image', image)
      }

      const updateUserResponse = await dispatch(updateUserThunk(data))
      if (isFulfilled(updateUserResponse)) {
        close()
      }
    }
  }

  return (
    <CustomPopup
      open={isOpenEditProfile}
      buttonClose={close}
      closeOnDocumentClick={false}
      className='edit-profile'
    >
      <div className='edit-profile__wrapper'>
        <div className='edit-profile__header'>Edit Profile</div>
        <UploadImage
          setImage={setImage}
          uploadedImage={user?.avatar_image_link}
          imageBorder='circle'
        />
        <GeneralForm {...setUpForm}>
          <TextInput label='Name' name='name' placeholder='Your name'>
            <Link to={NON_AUTH_ROUTE.RESET_PASSWORD} className='edit-profile__wrapper__link'>
              Reset password
            </Link>
          </TextInput>

          <div className='edit-profile__actions'>
            <CustomButton onClick={close} type='button' button='secondary'>
              Cancel
            </CustomButton>
            <CustomButton inProgress={inProgress} button='primary' type='submit'>
              Save
            </CustomButton>
          </div>
        </GeneralForm>
      </div>
    </CustomPopup>
  )
}

export default AddProjectModal
